module.exports = __webpack_public_path__ + "img/bus.8a8a0949.png";